import Lenis from 'lenis'

let lenis: Lenis | null = null
let rafId: number | null = null

export function useLenis() {
  const isMobile = () => {
    if (!import.meta.client)
      return false
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || ('ontouchstart' in window && window.innerWidth < 1024)
  }

  const initLenis = () => {
    if (import.meta.client && !lenis) {
      // Disable Lenis on mobile - native scrolling is better for touch devices
      if (isMobile()) {
        return
      }

      lenis = new Lenis({
        duration: 1.2,
        easing: t => Math.min(1, 1.001 - 2 ** (-10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        infinite: false,
        autoResize: true,
      })

      function raf(time: number) {
        lenis?.raf(time)
        rafId = requestAnimationFrame(raf)
      }

      rafId = requestAnimationFrame(raf)
    }
  }

  const destroyLenis = () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId)
      rafId = null
    }
    if (lenis) {
      lenis.destroy()
      lenis = null
    }
  }

  const scrollTo = (target: string | number, options?: any) => {
    lenis?.scrollTo(target, options)
  }

  const getLenis = () => lenis

  return {
    initLenis,
    destroyLenis,
    scrollTo,
    getLenis,
  }
}
